export enum EventType {
  ShiftStart = 1,
  ShiftEnd,
  BreakStart,
  BreakEnd,
  Pickup,
  Dropoff,
  DidNotShowUp,
}
